import noDecryptInstance from "../../utils/noDecryptApi";
import { toast } from "react-toastify";
import moment from "moment";

const DownloadAnyFile = async ({ url, payload = null, filename, ext }) => {
  try {
    let downloadedResult = null;
    if (payload)
      downloadedResult = await noDecryptInstance.post(url, payload, { responseType: 'blob' });
    else
      downloadedResult = await noDecryptInstance.get(url, { responseType: 'blob' });

    if (downloadedResult?.data) {
      const blob = new Blob([downloadedResult?.data], { type: ext === ".zip" ? "application/zip" : "text/plain" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a")
      link.href = url
      link.setAttribute(
        "download",
        `${filename}-${moment(new Date()).format("DD-MM-YYYY")}${ext}`
      )
      toast.success("File downloaded successfully.")
      document.body.appendChild(link)
      link.click()
      link.parentNode.removeChild(link)
    }

  } catch (error) {
    return error.response;
  }
}
export default DownloadAnyFile;